import Header from "../components/Header";
import Card from "../components/Card";
import Todocontainer from "../components/TodoContainer";
import { useLocation } from "react-router-dom"
function Landing(){
    const location = useLocation()
    let {username} = location.state ||{}
    return(<div className="bg-black p-16">
      <div className="bg-white p-10 border rounded-md">
        {/*Header*/}
        <Header username ={username} />
        {/*Card*/}
        <div className="flex py-5 justify-between gap-7 flex-wrap">
          <Card bgColor={"#8272DA"} title={"23°"} subtitle={"Chennai"} />
          <Card bgColor={"#FC6662"} title={"4 September"} subtitle={"13:07:01"} />
          <Card bgColor={"#FCA301"} title={"Build Using"} subtitle={"React"} />
        </div>
        {/*TodoContainer*/}
        <Todocontainer/>
        


      </div>
    </div>)
}
export default Landing